import {
  commitMutation,
  graphql
} from 'react-relay';
import environment from '../Environment';

const mutation = graphql`
  mutation GenerateSpidClientUrlMutation($ccnId: String!, $offerTypes: [OfferTypeEnum!]!) {
    generateSpidClientUrl(ccnId: $ccnId, offerTypes: $offerTypes) {
      ok
      error
      url
    }
  }
`;

export default ({ ccnId, offerTypes }, done) => {
  const variables = {
    ccnId,
    offerTypes
  };

  commitMutation(
    environment,
    {
      mutation,
      variables,
      onCompleted: (response) => {
        const { ok, error, url } = response.generateSpidClientUrl;
        done(ok, error, url);
      },
      onError: err => console.error(err)
    }
  );
};
